import { doesNativeConnectorExist, nativeOpenUrl } from './NativeConnector';
import { sendAnalytics } from './Reseller';

export const openLink = ({ callNativeHandler, url, analyticsName, target = '_blank' }) => {
  let operationPerformed = false;

  if (callNativeHandler && doesNativeConnectorExist()) {
    operationPerformed = true;
    nativeOpenUrl({ url });
  }
  if (!operationPerformed && url) {
    operationPerformed = true;
    window.open(url, target);
  }

  if (analyticsName && operationPerformed) {
    sendAnalytics({ name: analyticsName });
  }
};
